'use strict';

// ----------------------------------------
// Private
// ----------------------------------------

let $map = $('#map');
let icon = '/Media/assets/css/static/pic/map-marker.png';

function setPlace (latitude, longitude) {
	let place = new google.maps.LatLng(latitude, longitude); // eslint-disable-line no-undef

	return place;
}

// ----------------------------------------
// Public
// ----------------------------------------

function initMap () {
	if (!$map.length) {
		return false;
	}

	let location = {
		latitude: $map.data('lat'),
		longitude: $map.data('lng')
	};

	let map = new google.maps.Map(document.getElementById('map'), { // eslint-disable-line no-undef
		zoom: 15,
		center: setPlace(location.latitude, location.longitude),
		scrollwheel: false
	});

	let marker = new google.maps.Marker({ // eslint-disable-line no-undef, no-unused-vars
		position: setPlace(location.latitude, location.longitude),
		map: map,
		optimized: false,
		icon: icon,
		title: ''
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

export {initMap};



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/map.js